<template>
	<div>
		<pui-datatable :modelName="modelName" :actions="actions"></pui-datatable>
		<pui-docgen-template-modals :modelName="modelName"></pui-docgen-template-modals>
		<pui-docgen-template-parameters-dialog></pui-docgen-template-parameters-dialog>
	</div>
</template>

<script>
import PuiDocgenTemplateActions from './PuiDocgenTemplateActions.js';
import PuiDocgenTemplateModals from './PuiDocgenTemplateModals.vue';

export default {
	name: 'PuiDocgenTemplateGrid',
	components: { PuiDocgenTemplateModals },
	data() {
		return {
			modelName: 'puidocgentemplate',
			actions: PuiDocgenTemplateActions.actions
		};
	}
};
</script>
